import { useRef } from 'react';

import { useLegalClientSaveTargetedFinancialInstruments } from 'api/requests';
import { useServerErrorNotify } from 'hooks';

import { TargetedFinancialInstrumentsFormType } from '../forms/targetedFinancialInstrumentsForm';
import {
  getInitialData,
  getSubmitData,
} from '../helpers/targetedFinancialInstruments';

import { useOnboardingContext } from './useOnboardingContext';

export const useTargetedFinancialInstruments = () => {
  const { goToBack, goToNext, data } = useOnboardingContext();

  const {
    loading: submitLoading,
    error,
    saveTargetedFinancialInstruments,
  } = useLegalClientSaveTargetedFinancialInstruments();

  const initialValues = useRef(
    getInitialData(data.legalClient?.targetedFinancialInstruments)
  ).current;

  const onSubmit = async (values: TargetedFinancialInstrumentsFormType) => {
    const submitData = getSubmitData(values);
    await saveTargetedFinancialInstruments(data.legalClient!.id, submitData);
    goToNext();
  };

  useServerErrorNotify(error);

  return {
    initialValues,
    submitLoading,
    error,
    onSubmit,
    goToBack,
  };
};
